import Actions from 'actions'

export const PRESENCE_TTL_MS = 75000

const initialState = {
  byPatientId: {} // { [patientId]: { [sessionId]: { id, name, photo, sessionId, lastSeen } } }
}

// Key presence entries by sessionId so the same user's concurrent tabs/devices are tracked
// independently. Fall back to the user id for older clients that don't send a sessionId.
const sessionKeyOf = viewer => viewer.sessionId || viewer.id

const upsertViewer = (state, { patientId, viewer, now }) => {
  const sessionId = sessionKeyOf(viewer)
  return {
    ...state,
    byPatientId: {
      ...state.byPatientId,
      [patientId]: {
        ...(state.byPatientId[patientId] || {}),
        [sessionId]: { id: viewer.id, name: viewer.name, photo: viewer.photo, sessionId, lastSeen: now }
      }
    }
  }
}

const removeViewer = (state, { patientId, sessionId }) => {
  const existing = state.byPatientId[patientId]
  if (!existing || !existing[sessionId]) return state
  const { [sessionId]: _removed, ...rest } = existing
  const byPatientId = { ...state.byPatientId }
  if (Object.keys(rest).length) byPatientId[patientId] = rest
  else delete byPatientId[patientId]
  return { ...state, byPatientId }
}

const pruneStale = (state, { now, ttlMs }) => {
  let changed = false
  const byPatientId = {}
  Object.entries(state.byPatientId).forEach(([patientId, viewers]) => {
    const fresh = {}
    Object.values(viewers).forEach(v => {
      if (now - v.lastSeen <= ttlMs) fresh[v.sessionId] = v
      else changed = true
    })
    if (Object.keys(fresh).length) byPatientId[patientId] = fresh
  })
  return changed ? { ...state, byPatientId } : state
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.PATIENT_PRESENCE_RECEIVED: {
      const { patientId, action: presenceAction, viewer, now } = action.payload
      return presenceAction === 'close'
        ? removeViewer(state, { patientId, sessionId: sessionKeyOf(viewer) })
        : upsertViewer(state, { patientId, viewer, now })
    }
    case Actions.PRUNE_PATIENT_PRESENCE:
      return pruneStale(state, { now: action.payload.now, ttlMs: PRESENCE_TTL_MS })
    case Actions.SIGNOUT_RECEIVED:
      return initialState
    default:
      return state
  }
}
